@if (visible) {
  <div class="modal_customer"
    >
    <div class="modal_customer_body">
      <div class="modal_text_md">Feedback submitted</div>
      <br>
        <div class="modal_text_sm">
          Thank you for your rating. We will provide your feedback<br>
          to the contractor who served you.<br>
        </div>
        <br>
          <br>
          </div>
        </div>
      }
